module.exports = InternalShared('InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties');